import { Tabs, Tab } from 'components/tabs'
import { PageHeader } from 'components/page-header'
import { Link, useLocation, useParams, useRouteMatch } from 'react-router-dom'
import ActivityPlansStageRoutes from 'routes/activity-plans-stage-routes'
import { urlToTitle } from '../lib/transformStage'
import useStyles from './styles'
import {
  ActivityPlanDetailHeaderProvider,
  useActivityPlanDetailHeader,
} from '../activity-plan-detail-header-context'

const StagePageContent = () => {
  const { stage } = useParams()
  const styles = useStyles()
  const match = useRouteMatch()
  const path = match.url
  const location = useLocation()
  const {
    detailTitle,
    detailSubtitle,
    actionsTarget,
  } = useActivityPlanDetailHeader()
  const isDetails =
    !location.pathname.endsWith('activities') &&
    !location.pathname.endsWith('plans')

  const listPath = location.pathname
    .split('/')
    .slice(0, 6)
    .join('/')

  const crumbs = [
    {
      label: 'Activity Plans',
      to: path
        .split('/')
        .slice(0, 4)
        .join('/'),
    },
    ...(isDetails
      ? [
        {
          label: urlToTitle(stage).title,
          to: listPath,
        },
      ]
      : []),
  ]

  return (
    <>
      <PageHeader
        title={isDetails ? detailTitle || '' : urlToTitle(stage).title}
        subtitle={isDetails ? detailSubtitle : undefined}
        crumbs={crumbs}
        actions={isDetails ? actionsTarget : undefined}
        keepActionsInline={isDetails}
        fixedMobileActions={isDetails}
        tabs={
          <Tabs
            value={window.location.pathname}
            className={`${isDetails ? styles.hiddenTabs : ''}`}
          >
            <Tab
              label="Activities"
              value={`${path}/activities`}
              component={Link}
              to={`${path}/activities`}
            />
            <Tab
              label="Featured Plans"
              value={`${path}/plans`}
              component={Link}
              to={`${path}/plans`}
            />
          </Tabs>
        }
      />
      <ActivityPlansStageRoutes />
    </>
  )
}

const StagePage = () => (
  <ActivityPlanDetailHeaderProvider>
    <StagePageContent />
  </ActivityPlanDetailHeaderProvider>
)

export default StagePage
